module YVR.Utilities.MediaQueries {
	export interface IMediaQueryEventObject extends JQueryEventObject {
		type: string;
		state: string;
		action: string;
	}

	// Cached jQuery elements
	const elements = {
		html: $('html'),
		window: $(window)
	};

	export const changeEvent = 'yvrMqChange';
	export const thresholds = {
		xs: 'screen and (max-width: 543px)',
		sm: 'screen and (min-width: 544px) and (max-width: 767px)',
		md: 'screen and (min-width: 768px) and (max-width: 991px)',
		lg: 'screen and (min-width: 992px) and (max-width: 1199px)',
		xl: 'screen and (min-width: 1200px)',
		xxl: 'screen and (min-width: 1440px)'
	};
	export let state = null;


	/**
	 * Sets up events so that we can fire script for particular media queries
	 * or when a user goes from one threshold to another
	 */
	function initMediaQueryEvents() {
		if ((window as any).Harvey) {
			// Our media query vendor lib has been loaded (Harvey)
			$.each(thresholds, (key, value) => {
				(window as any).Harvey.attach(value, {
					setup() {
						mqState(key, 'setup');
					},
					on() {
						mqState(key, 'enter');
					},
					off() {
						mqState(key, 'exit');
					}
				});
			});
		}
	}


	/**
	 * Gets fired when media query state changes
	 *
	 * @param {string} state Media query state
	 * @param {string} action Action occurring (i.e. setup, enter, exit)
	 */
	function mqState(newState, action) {
		if (action === 'enter') {
			state = newState;

			// Set a class on the body indicating our new state
			elements.html.removeClass('yvr-xs yvr-sm yvr-md yvr-lg yvr-xl yvr-xxl').addClass(`yvr-${state}`);
		}

		elements.html.trigger({
			type: changeEvent,
			state,
			action
		} as any);
	}


	function main() {
		initMediaQueryEvents();
	}


	main();
}
